<template>
    <div id="menu-slider" 
        class="slider__container"
    >
        <span class="slider__hint">{{ hint }}</span>
        <v-slider
            v-model="selected_tick_index"
            step="1"
            :max="slide_ticks.length - 1"
            ticks="always"
            :tick-labels="slide_ticks"
            hide-details
        />
    </div>
</template>

<script>
    export default {
        name: 'Slider',

        props: {
            item: {
                type: Object,
                require: true,
                default: () => ({})
            },

            tick_id: {
                type: String,
                require: true,
                default: '',
            },

            slider_ticks_mapping: {
                type: Object,
                default () {
                    return {}
                }
            },
        },

        data() {
            return {
                // slider_ticks_mapping: {
                //     "id_10": 1, "id_11": 3, "id_12": 6, "id_32": 12, "id_24": 24, 
                //     "id_26": 1, "id_27": 3, "id_28": 6, "id_29": 12, "id_30": 24, "id_31": 72,
                //     "id_47": 1, "id_48": 3, "id_49": 6, "id_50": 12, "id_51": 24,
                //     "id_52": 1, "id_53": 3, "id_54": 6, "id_55": 12, "id_56": 24,
                //     "id_57": 1, "id_58": 3, "id_59": 6, "id_60": 12, "id_61": 24,
                // },

                selected_tick_index: null,
            }
        },

        computed: {
            sliders() {
                return this.item.sliders
            },

            hint() {
                return this.item.hint
            },

            slide_ticks() {
                return this.sliders.map(({ id }) => this.slider_ticks_mapping[id])
            },

            selected_slide() {
                // 用於給 parent 元件存取
                return this.sliders[this.selected_tick_index]
            },
        },

        watch: {
            tick_id: {
                immediate: true,
                handler() {
                    // 有時候會沒傳，只是 undefined
                    if (this.tick_id) {
                        this.selected_tick_index = this.sliders.findIndex(({ id }) => id === this.tick_id)
                    }
                },
            },
            
            selected_tick_index() {
                const selected_tick_id = this.sliders[this.selected_tick_index].id
                this.$emit('change-slider-tick', this.item, selected_tick_id)
            }
        },
    }
</script>

<style lang="scss" scoped>
    .slider {
        &__container {
            position: relative;
            margin-top: 2rem;

            &::before {
                content: '';
                position: absolute;
                top: 5%;
                left: -27px;
                width: 1px;
                height: 95%;
                background: var(--base-gray-darken);
            }
        }

        &__hint {
            position: absolute;
            top: -2rem;
            right: 0;
            font-size: .75rem;
            letter-spacing: .5px;
            line-height: 1.33;
        }
    }
</style>

<style scoped>
    .slider__container >>> .v-slider__tick {
        top: calc(50% - .1875rem) !important;
        height: .375rem !important;
        background-color: #fff;
    }

    .slider__container >>> .v-slider__track-fill {
        background-color: #fff !important;
    }

    .slider__container >>> .v-slider__track-background.v-slider__track-background {
        /* 重複兩次 .v-slider__track-background 是為了加高權重 */
        background-color: #fff !important;
    }

    .slider__container >>> .v-slider__tick-label {
        top: -1.5rem;
        font-size: .75rem;
        letter-spacing: .5px;
        line-height: 1.33;
        text-align: center;
    }

    .slider__container >>> .v-slider__thumb {
        left: initial;
        transform: translate(-50%, -50%);
        width: 1rem;
        height: 1rem;
        background-color: #fff !important;
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, .5);
    }

    .slider__container >>> .v-slider__thumb::before {
        content: none;
    }
</style>